module.exports = __webpack_public_path__ + "img/riskBasedMonitoring.9d830b63.svg";